import { InternationalizationNameSpace } from '~/constants/internationalization-namespace';
import { fallbackLng, translatedLocales } from '~/config/i18n/languages';
import { i18nFilesLocations } from '~/config/i18n/files-locations';

export type Locale = (typeof translatedLocales)[number];

type LazyImportFunction = () => Promise<unknown>;
type NamespaceImportConfig = { [key in InternationalizationNameSpace]?: LazyImportFunction };

const multiLocaleNamespaces = i18nFilesLocations.filter((loc) => loc.translated);
const inProgressNamespaces = i18nFilesLocations.filter((loc) => !loc.translated);

// Resource Builder
const resources = Object.fromEntries(
  translatedLocales.map((locale) => {
    const nsConfig: NamespaceImportConfig = Object.fromEntries([
      ...multiLocaleNamespaces.map(({ ns, loader }) => [ns, () => loader(locale)]),
      ...(locale === fallbackLng
        ? inProgressNamespaces.map(({ ns, loader }) => [ns, () => loader(fallbackLng)])
        : []),
    ]);
    return [locale, nsConfig];
  })
);

export { resources };
